// src/pages/LandingPage/Pricing.jsx
import {
  Box,
  Button,
  Container,
  Heading,
  List,
  ListItem,
  ListIcon,
  Text,
  SimpleGrid,
  useColorModeValue
} from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';
import { Link as RouterLink } from 'react-router-dom';

const PriceCard = ({ title, price, description, features, isPopular }) => {
  return (
    <Box
      bg={useColorModeValue('white', 'gray.800')}
      borderRadius="lg"
      p={8}
      boxShadow={isPopular ? 'xl' : 'md'}
      border={isPopular ? '2px solid' : 'none'}
      borderColor="brand.primary"
      transform={isPopular ? { base: 'none', md: 'scale(1.05)' } : 'none'}
      transition="all 0.3s ease"
      _hover={{
        transform: 'translateY(-10px)',
        boxShadow: 'xl',
      }}
    >
      <Heading as="h3" size="lg" color="brand.primary" mb={2}>
        {title}
      </Heading>
      <Text fontSize="4xl" fontWeight="bold" mb={2}>
        {price}
        <Text as="span" fontSize="md" color="gray.500" fontWeight="normal">
          {description}
        </Text>
      </Text>
      <List spacing={3} mt={6} mb={8}>
        {features.map((feature, index) => (
          <ListItem key={index}>
            <ListIcon as={CheckIcon} color="brand.secondary" />
            {feature}
          </ListItem>
        ))}
      </List>
      <Button
        as={RouterLink}
        to="/signup"
        w="full"
        bgGradient="linear(to-r, brand.primary, brand.secondary)"
        color="white"
        borderRadius="full"
        _hover={{
          transform: 'translateY(-2px)',
          boxShadow: '0 5px 15px rgba(165, 180, 232, 0.4)',
        }}
      >
        Escolher Pacote
      </Button>
    </Box>
  );
};

const Pricing = () => {
  return (
    <Box bg={useColorModeValue('white', 'gray.800')} py={20} id="precos">
      <Container maxW={'1200px'}>
        <Heading
          as="h2"
          fontSize={{ base: '3xl', md: '4xl' }}
          textAlign={'center'}
          mb={16}
          color="brand.primary"
        >
          Escolha seu pacote
        </Heading>

        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: 8, md: 10 }}>
          <PriceCard
            title="Pacote Básico"
            price="R$15"
            description=" / 3 desenhos"
            features={[
              '3 créditos para transformar fotos',
              'Download em alta resolução',
              'Acesso à galeria pessoal',
            ]}
          />
          <PriceCard
            title="Pacote Plus"
            price="R$44"
            description=" / 10 desenhos"
            features={[
              '10 créditos para transformar fotos',
              'Economize R$6,00',
              'Download em alta resolução',
              'Acesso à galeria pessoal',
            ]}
            isPopular
          />
          <PriceCard
            title="Pacote Premium"
            price="R$85"
            description=" / 20 desenhos"
            features={[
              '20 créditos para transformar fotos',
              'Economize R$15,00',
              'Download em alta resolução',
              'Acesso à galeria pessoal',
              'Prioridade no processamento',
            ]}
          />
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default Pricing;